<script>
import DataLayer from '@services/data-layer/index'
import MixGridTile from '@components/mix-grid-tile'
import { shuffleArray } from '@utils/arrays'

const HOT_DROPS_FETCH_LIMIT = 10
const HOT_DROPS_DISPLAY_LIMIT = 4

export default {
    components: { MixGridTile },
    data() {
        return {
            mixes: [],
        }
    },
    computed: {
        currentUserId() {
            return this.$store.state.auth.currentUser?.members_id?.id
        },
    },
    mounted() {
        this.getRecommendedMixes()
    },
    methods: {
        async getRecommendedMixes() {
            if (!this.currentUserId) return

            const mixes = await DataLayer.mixes.getRecommended(this.currentUserId, HOT_DROPS_FETCH_LIMIT)
            this.mixes = shuffleArray(mixes.body).slice(0, HOT_DROPS_DISPLAY_LIMIT)
        },
    },
}
</script>

<template>
    <div
        v-if="mixes && mixes.length"
        class="section"
    >
        <BaseSection
            title="Hot Drops for you"
            subtitle="Mixes we think you'll dig"
            padded
        >
            <carousel
                :per-page-custom="[[0, 2], [768, 3], [1025, 6]]"
                :pagination-enabled="false"
                :navigation-enabled="false"
                :scroll-per-page="false"
                :min-swipe-distance="100"
                :space-padding="0"
                class="carousel"
            >
                <slide
                    v-for="(mix, index) in mixes"
                    :key="`homepage-hot-drops-${mix.id}-${index}`"
                    class="slide"
                >
                    <MixGridTile
                        :mix="mix"
                        :index="index"
                    />
                </slide>
            </carousel>
        </BaseSection>
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;

.section {
    position: relative;
    z-index: 2;
    margin-top: $s-xxl;
}

.carousel {
    position: relative;
    z-index: 3;
    margin: 0 (-$size-grid-padding);
    overflow: visible;
}

.slide {
    position: relative;
    padding: 0 $size-grid-padding;

    &:hover,
    &:focus-within {
        z-index: 4;
    }
}

:deep(.carousel .VueCarousel-wrapper),
:deep(.carousel .VueCarousel-inner),
:deep(.carousel .VueCarousel-slide) {
    overflow: visible;
}
</style>
